import React, {memo} from 'react';
import {NavLink} from 'react-router-dom';
import * as Assets from '../../assets/images/images';

import {Constants} from '../../helpers';
import {
  NavigationItem,
  SubNavigationDropdown,
  SubNavigationItem,
} from './components';
import {usePermissions} from 'hooks/useSidbarPermissions';
import {apiLogsMobileNav, apiLogsNav} from '../../assets/images/images';
import {
  BaasCustomers,
  BaasOverview,
  BaasPayouts,
  BaasSettings,
  BaasTransactions,
  BaasWallets,
  Developers,
  Logs,
} from 'components/images/sidebar';

const TrypilaSideNavigations = memo(
  ({media, splitLocation, pathname, openDropdown, toggleSubRoute}) => {
    const {USER_PERMISSIONS} = usePermissions();
    return (
      <>
        <div className="">
          <NavigationItem
            media={media}
            title={<div className="flex items-center   gap-2">Overview</div>}
            to={Constants.PAGES_URL.BAAS_OVERVIEW}
            IconComponent={BaasOverview}
          />
        </div>

        <div className="mt-2">
          <NavigationItem
            media={media}
            title={<div className="flex items-center   gap-2">Customers</div>}
            to={Constants.PAGES_URL.BAAS_CUSTOMERS}
            IconComponent={BaasCustomers}
          />
        </div>

        <div className="mt-2">
          <NavigationItem
            media={media}
            title={
              <div className="flex items-center   gap-2">Transactions</div>
            }
            to={Constants.PAGES_URL.BAAS_TRANSACTIONS}
            IconComponent={BaasTransactions}
          />
        </div>

        <div className="mt-2">
          <NavigationItem
            media={media}
            title={<div className="flex items-center   gap-2">Wallets</div>}
            to={Constants.PAGES_URL.BAAS_WALLETS}
            IconComponent={BaasWallets}
          />
        </div>

        <div className="mt-2">
          <NavigationItem
            media={media}
            title={<div className="flex items-center   gap-2">Payouts</div>}
            to={Constants.PAGES_URL.BAAS_PAYOUTS}
            IconComponent={BaasPayouts}
          />
        </div>

        <div className="mt-2">
          <NavigationItem
            media={media}
            title={<div className="flex items-center   gap-2">Settings</div>}
            to={Constants.PAGES_URL.BAAS_SETTINGS}
            IconComponent={BaasSettings}
          />
        </div>

        <div className="mt-2 flex flex-col gap-2 rounded lg:text-white text-grey">
          <SubNavigationDropdown
            media={media}
            IconComponent={Developers}
            toggleSubRoute={() => toggleSubRoute('developers')}
            src={media ? Assets.developersNav : Assets.developersMobileNav}
            open={openDropdown === 'developers'}
            label="Developers"
            subRoutes={[
              Constants.PAGES_URL.DEVELOPERS_API_LOGS,
              Constants.PAGES_URL.DEVELOPERS_CONFIGURATION,
              Constants.PAGES_URL.DEVELOPERS_WEBHOOK,
              Constants.PAGES_URL.API_TOKENS,
            ]}
          />

          {openDropdown === 'developers' && (
            <div className="flex flex-col">
              <SubNavigationItem
                media={media}
                title="API Logs"
                active={splitLocation[1] === ''}
                to={Constants.PAGES_URL.DEVELOPERS_API_LOGS}
                webIcon={apiLogsNav}
                mobileIcon={apiLogsMobileNav}
                inner
              />
              <SubNavigationItem
                media={media}
                title="Configuration"
                active={splitLocation[1] === ''}
                to={Constants.PAGES_URL.DEVELOPERS_CONFIGURATION}
                webIcon={Assets.configurationNav}
                mobileIcon={Assets.configurationMobileNav}
                inner
              />

              <SubNavigationItem
                media={media}
                title="Webhooks"
                active={splitLocation[1] === ''}
                to={Constants.PAGES_URL.DEVELOPERS_WEBHOOK}
                webIcon={Assets.webhookNav}
                mobileIcon={Assets.webhookMobileNav}
                inner
              />
            </div>
          )}
        </div>

        <div className="mt-2">
          <NavigationItem
            media={media}
            title={<div className="flex items-center   gap-2">Logs</div>}
            IconComponent={Logs}
            active={
              pathname === Constants.PAGES_URL.AUDIT_LOGS ||
              pathname === Constants.PAGES_URL.EXPORT_LOGS
            }
            to={Constants.PAGES_URL.AUDIT_LOGS}
          />
        </div>

        <div className="flex flex-col mt-2">
          <SubNavigationDropdown
            media={media}
            toggleSubRoute={() => toggleSubRoute('settings')}
            src={media ? Assets.settingsNav : Assets.settingsMobileNav}
            open={openDropdown === 'settings'}
            label="Settings"
            subRoutes={[
              Constants.PAGES_URL.SETTINGS_PROFILE,
              Constants.PAGES_URL.SETTINGS_COMPANY_VERIFICATION,
              Constants.PAGES_URL.SETTINGS_ORGANISATION,
              Constants.PAGES_URL.SETTINGS_TEAM,
            ]}
          />

          {openDropdown === 'settings' && (
            <>
              <NavLink
                to={Constants.PAGES_URL.SETTINGS_PROFILE}
                className={`nav-item rounded flex lg:hidden items-center gap-2 pl-8 py-2 relative ${splitLocation[1]} === "" ? "active" : ""`}
                aria-current="page"
              >
                <img
                  src={Assets.settingsMobileNav}
                  alt=""
                  width={18}
                  height={18}
                />
                <span className="-mb-1 text-sm text-body">All settings</span>
              </NavLink>
              <div className="flex-col hidden lg:flex">
                <SubNavigationItem
                  media={media}
                  title="Profile"
                  active={splitLocation[1] === ''}
                  to={Constants.PAGES_URL.SETTINGS_PROFILE}
                  webIcon={Assets.profileNav}
                  mobileIcon={Assets.settingsMobileNav}
                  inner
                />

                {USER_PERMISSIONS?.role === 'Owner' && (
                  <SubNavigationItem
                    media={media}
                    title="Company Verification"
                    active={splitLocation[1] === ''}
                    to={Constants.PAGES_URL.SETTINGS_COMPANY_VERIFICATION}
                    webIcon={Assets.auditLogsNav}
                    mobileIcon={Assets.verifyIc}
                    inner
                  />
                )}

                {/*<SubNavigationItem*/}
                {/*  media={media}*/}
                {/*  title="Team"*/}
                {/*  active={splitLocation[1] === ''}*/}
                {/*  to={Constants.PAGES_URL.SETTINGS_TEAM}*/}
                {/*  webIcon={teamNav}*/}
                {/*  mobileIcon={teamNav}*/}
                {/*  inner*/}
                {/*/>*/}
              </div>
            </>
          )}
        </div>
      </>
    );
  },
);

export {TrypilaSideNavigations};
